export default __webpack_public_path__ + "static/make-a-living-designing-logos-hardcover@2x-8e38d99c678a309296944dbcbc5f6b6d.png";